import {Component, Input} from "@angular/core";
import {Brand, Occasion} from "../../../../../../../../../server/src/base/entities/occasion/Occasion";
import {Router} from "@angular/router";
import {environment} from "../../../../../../../environments/environment";

/**
 * Created by Benoit Valkenberg on 10-12-17.
 */
@Component({
    selector: 'occasions-light',
    styleUrls: ['./occasions-light.scss'],
    templateUrl: './occasions-light.html'
})
export class OccasionsLightComponent {

    @Input() occasion:Occasion;
    public brandUrl:string;

    constructor(private router:Router){

    }

    ngOnInit(){
        this.brandUrl = environment.clientUrl + "assets/img/brands/" + Brand[this.occasion.brand] + ".png";
    }

    public onClick(){
        window.open(this.occasion.link, '_blank');
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-light/occasions-light.ts